import moment from "moment/moment";
import {KeyConstant} from "../../../can/weighing-slip/constant/keyConstant";

export const dataListWeek = () => {
    return [
        {
            title: "Tuần này",
            startDate: moment().startOf("week"),
            endDate: moment().endOf("week"),
            key: KeyConstant.THIS_WEEK
        },
        {
            title: "Tuần trước",
            startDate: moment().subtract(1, "weeks").startOf("week"),
            endDate: moment().subtract(1, "weeks").endOf("week"),
            key: KeyConstant.LAST_WEEK
        },
        {
            title: "7 ngày trước",
            startDate: moment().subtract(7, "days"),
            endDate: moment().subtract(1, "days"),
            key: KeyConstant.SEVEN_DAYS_AGO
        }
    ]
}
